import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'filterByStates'
})
export class FilterByStatesPipe implements PipeTransform {

	transform(items: Array<any>, states: any = []): Array<any> {
		if (!items) {
			return [];
		}
		if (!states.length) {
			return items;
		}
		return items.filter(item => {
			return states.some(state => {
				if (item.hasOwnProperty('address')) {
					if (item.address.hasOwnProperty('state')) {
						if (item.address.state.hasOwnProperty('name')) {
							return item.address.state.name === state;

						} else {
							return false;
						}
					}
				} else {
					return false;
				}
			});
		});
	}

}
